import Airport from '../types/airport';

export const getICAOLabelFromAirport = (a: Airport) => (a ? a.ICAO : 'N/A');
export const getIATALabelFromAirport = (a: Airport) =>
  a && a.IATA ? a.IATA : 'N/A';
export const getCityLabelFromAirport = (a: Airport) =>
  (a && a.place && a.place.city) || 'N/A';
export const getCountryLabelFromAirport = (a: Airport) =>
  (a && a.place && a.place.country) || 'N/A';
